export const FETCH_PRODUCT_STATUSES = "FETCH_PRODUCT_STATUSES";
export const FETCH_PRODUCT_STATUS = "FETCH_PRODUCT_STATUS";
export const CREATE_PRODUCT_STATUS = "CREATE_PRODUCT_STATUS";
export const UPDATE_PRODUCT_STATUS = "UPDATE_PRODUCT_STATUS";
export const DELETE_PRODUCT_STATUS = "DELETE_PRODUCT_STATUS";

export function fetchProductStatuses(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_PRODUCT_STATUSES,
    auth: true,
    payload: {
      url: "superuser/product-status",
      method: "GET",
      params
    }
  };
}

export function fetchProductStatus(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_PRODUCT_STATUS,
    auth: true,
    payload: {
      url: `superuser/product-status/${id}`,
      method: "GET",
      params
    }
  };
}

export function createProductStatus(data = {}) {
  return {
    type: CREATE_PRODUCT_STATUS,
    auth: true,
    payload: {
      url: "superuser/product-status",
      method: "POST",
      data
    }
  };
}

export function updateProductStatus(id, data = {}) {
  return {
    type: UPDATE_PRODUCT_STATUS,
    auth: true,
    payload: {
      url: `superuser/product-status/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteProductStatus(id, data = {}) {
  return {
    type: DELETE_PRODUCT_STATUS,
    auth: true,
    payload: {
      url: `superuser/product-status/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/productStatus.js